import React from "react";
import ReactTable from 'react-table';
import withFixedColumns from 'react-table-hoc-fixed-columns';

import {isMobile} from 'react-device-detect';

import AppService from '../service/AppService';


// import SellerService from '';

const appConfig:AppConfig = AppService.appConfig();

const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default class ItemShippingFeeListComponent extends React.Component {
  constructor(props) {
    super(props);

    // let sellerService = new SellerService();

    // return sellerService.findSellerProductModelsByCluezCatalogId(68895)
    //   .then(data => {
    //     console.log(data)
    //     expect(data.data.searchResult.count).toBeGreaterThan(0);
    //   });
    this.state = {
      range: [
        "注文総額",
        "1〜9,999円", 
        "10,000〜19,999円", 
        "20,000〜49,999円", 
        "50,000〜99,999円", 
        "100,000〜249,999円", 
        "250,000〜274,999円", 
        "275,000〜299,999円", 
        "300,000〜324,999円", 
        "350,000〜399,999円",
        "400,000〜999,999円",
        "250,000〜274,999円",
        "275,000〜299,999円",
        "300,000〜324,999円",
        "350,000〜399,999円"
      ],
      data: [{
          prefecture: '北海道',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '東北',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '北陸・甲信越',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '関東',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '中部',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '近畿',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '中国',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '四国',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '九州',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '沖縄',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        },{
          prefecture: '離島エリア',
          price1: '999,999円',
          price2: '999,999円',
          price3: '999,999円',
          price4: '999,999円',
          price5: '999,999円',
          price6: '999,999円',
          price7: '999,999円',
          price8: '999,999円',
          price9: '999,999円',
          price10: '999,999円',
          price11: '999,999円',
          price12: '999,999円',
          price13: '999,999円',
          price14: '999,999円'
        }
    ]
    }
  }

  render() {
    const data = this.state.data;
    const range = this.state.range;

    if (!isMobile) {

      let columnsData = [];
      for (let i = 0; i < data.length; i++){
        if(i == 0){
          columnsData.push({
            Header: range[i],
            accessor: 'prefecture',
            width: 110,
            fixed: 'left'
          });
        } else {
          columnsData.push({
            Header: range[i],
            accessor: 'price'+(i+1),
            width: 150
          });
        }
      }

      const columns = columnsData;

      return (
        <div>
          <ReactTableFixedColumns
            data={data}
            columns={columns}
            sortable={false}
            resizable={false}
            footer={false}
            className="shipping-fee-table table-vh-hover -highlight"
            showPagination={false}
            showPageSizeOption={false}
            showPageJump={false}
            defaultPageSize={10}
          />
        </div>
      );
    } else {
      
      let tblData = data.map((table, index) => {
        let rows = [];
        rows.push(
          <tr>
            <th>注文総額</th>
            <th>配送料</th>
          </tr>
        );
        for(let i = 0; i < range.length; i++){
          rows.push(
            <tr>
              <td>{range[i]}</td>
              <td>{table['price'+(index+1)]}</td>
            </tr>
          );
        }
        return (
          <div className="shipping-fee-group-mobile">
            <h2>{table.prefecture}</h2>
            <table>
              {rows}
            </table>
          </div>
        );
      });

      return tblData;

      
    }
  }
}

